// 积分管理
export default [
  {
    path: "/pointManage",
    meta: { title: "积分管理" },
    component: () => import("../views/pointManage/index"),
    children: [
      {
        path: "/pointManage/pointSetUp",
        name: "pointSetUp",
        meta: { title: "积分设置", isMenu: true },
        component: () => import("../views/pointManage/pointSetUp"),
      },
      {
        path: "/pointManage/pointDetails",
        name: "pointDetails",
        meta: { title: "积分明细", isMenu: true },
        component: () => import("../views/pointManage/pointDetails"),
      },
    ],
  },
]
